export const LIST_FILTER_LOCALE_ZHCHS = {
    filter: 'ç­é',
    confirm: 'ç¡®å®',
    cancel: 'åæ¶',
    reset: 'æ¸ç©ºæ¡ä»¶'
};
